import { render, staticRenderFns } from "./guide-video.vue?vue&type=template&id=15ce9707&scoped=true&"
import script from "./guide-video.vue?vue&type=script&lang=js&"
export * from "./guide-video.vue?vue&type=script&lang=js&"
import style0 from "./guide-video.vue?vue&type=style&index=0&id=15ce9707&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce9707",
  null
  
)

export default component.exports